module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: [_vm.css.wrapperClass]
  }, [_c('a', {
    class: [_vm.css.linkClass, ( _obj = {}, _obj[_vm.css.disabledClass] = _vm.isOnFirstPage, _obj )],
    on: {
      "click": function($event) {
        _vm.loadPage('prev')
      }
    }
  }, [_c('i', {
    class: _vm.css.icons.prev
  })]), _vm._v(" "), _c('select', {
    class: ['vuetable-pagination-dropdown', _vm.css.dropdownClass],
    on: {
      "change": function($event) {
        _vm.loadPage($event.target.selectedIndex + 1)
      }
    }
  }, _vm._l((_vm.totalPage), function(n) {
    return _c('option', {
      class: [_vm.css.pageClass],
      domProps: {
        "value": n,
        "selected": _vm.isCurrentPage(n)
      }
    }, [_vm._v("\n      " + _vm._s(_vm.pageText) + " " + _vm._s(n) + "\n    ")])
  })), _vm._v(" "), _c('a', {
    class: [_vm.css.linkClass, ( _obj$1 = {}, _obj$1[_vm.css.disabledClass] = _vm.isOnLastPage, _obj$1 )],
    on: {
      "click": function($event) {
        _vm.loadPage('next')
      }
    }
  }, [_c('i', {
    class: _vm.css.icons.next
  })])])
  var _obj;
  var _obj$1;
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-397c17ed","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VuetablePaginationDropdown.vue
// module id = 112
// module chunks = 1